import tailwindConfig from '../../tailwind.config';

export const breakpoints = {
  TABLET: parseInt(tailwindConfig.theme.screens.md, 10),
  DESKTOP: parseInt(tailwindConfig.theme.screens.lg, 10),
};
